import { Skeleton } from "@mui/material";
import { DataRow } from "Theme/components";

interface PaperLoadingProps {
  readonly loading: boolean;
  readonly children?: React.ReactNode;
}

function PaperLoading({ children, loading }: PaperLoadingProps) {
  return loading ? (
    <DataRow
      label={
        <Skeleton
          component="span"
          variant="rectangular"
          width="64px"
          height="64px"
        />
      }
      divider={true}
    >
      <Skeleton variant="rectangular" width="200px" />
    </DataRow>
  ) : (
    <>{children}</>
  );
}

export default PaperLoading;